import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';
import { LoaderService } from 'src/app/utils/loader.service';
import { Inspection } from '../../interfaces/VendorOrder';

interface DialogData {
  batch_id: any
}

@Component({
  selector: 'app-move-to-inventory',
  templateUrl: './move-to-inventory.component.html',
  styleUrls: ['./move-to-inventory.component.scss']
})
export class MoveToInventoryComponent implements OnInit {
  private filesControl = new FormControl(
    null,
    FileUploadValidators.filesLimit(6)
  );
  public demoForm = new FormGroup({
    files: this.filesControl
  });
  partData;
  orderCode;
  orderId;
  QtyToMoveToInventory: number = 1;
  inputQty;
  inventory_count;
  total_quantity;
  clicked = false;
  inspection_file: any;
  fileUploaded: boolean;
  image_url: string | ArrayBuffer;
  batchId: any;
  batchDetails: any;
  currentBatch: any;
  totalPassedQty: any;
  currentInventoryCount: any;
  lastInspectionPassed: number;
  currentInspectedQty: number;

  constructor(
    private adminService: AdminService,
    private toastr: ToastrService,
    public dialogref: MatDialogRef<MoveToInventoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private loaderService: LoaderService

  ) { }

  ngOnInit() {
    console.log(this.data);
    this.partData = this.data["data"];
    this.batchId = this.data.batch_id;
    this.orderCode = this.data["order_code"];
    this.orderId = this.data["order_id"];
    this.inventory_count = this.partData.inventory_count;
    this.total_quantity = this.partData.quantity
    this.attachFiles();
    this.getCurrentBatch();
  }

  getCurrentBatch() {
    this.currentBatch = this.partData?.dispatch_batch.filter((batch) => batch?._id === this.batchId)[0];
    console.log(this.currentBatch)
    const { passedQuantity, inspectedQuantity, lastPassedQuantity } = this.getLatestBatchSession(this.currentBatch.inspections) || {};
    this.totalPassedQty = passedQuantity ? passedQuantity : 0;
    this.lastInspectionPassed = lastPassedQuantity? lastPassedQuantity : 0;
    this.currentInspectedQty = inspectedQuantity ? inspectedQuantity : 0;
    this.currentInventoryCount = this.currentBatch?.inventoryQuantity;

    this.QtyToMoveToInventory = this.totalPassedQty;
    if (this.totalPassedQty > this.lastInspectionPassed) {
      this.QtyToMoveToInventory = this.totalPassedQty - this.lastInspectionPassed;
    }
    if(this.totalPassedQty===this.currentInventoryCount || this.totalPassedQty===this.currentBatch?.shippedQuantity){
      this.QtyToMoveToInventory = 0;
    }
  }

  getLatestBatchSession(sessions: Inspection[]): Inspection {
    // Find the session with the maximum _id
    if (sessions.length === 0) return null;
    const maxIdSession = sessions.reduce((maxSession, currentSession) => {
      return currentSession._id > maxSession._id ? currentSession : maxSession;
    }, sessions[0]);
    return maxIdSession
  }

  attachFiles() {
    const stageFileData = this.demoForm.get("files");
    stageFileData.valueChanges.subscribe((res: any) => {
      this.inspection_file = res[0];
      this.fileUploaded = true;
      this.previewUploadedFile(this.inspection_file);
    });
  }

  previewUploadedFile(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      this.image_url = event.target.result;
    };
  }

  changeQty(event) {
    this.inputQty = parseInt(event)
    if (Number.isNaN(this.inputQty)) {
      this.toastr.error('Not a number', 'Error');
      this.QtyToMoveToInventory = 0
      return;
    }
    this.QtyToMoveToInventory = this.inputQty;
    // const balanceQty = this.partData.quantity - this.partData.shipped_count - this.partData.inventory_count
    // if (this.QtyToMoveToInventory > (balanceQty)) {
    if (this.QtyToMoveToInventory > this.currentBatch?.inspectionPassedQuantity) {
      this.toastr.error('Quantity cannot exceed passed quantity', 'Error');
      this.QtyToMoveToInventory = this.currentBatch?.inspectionPassedQuantity;
      return
    }
    // this.toastr.error('Quantity cannot exceed balance quantity', 'Error');
    // this.QtyToMoveToInventory = balanceQty
    // }
  }

  addQuantity() {
    if (this.QtyToMoveToInventory >= (this.partData.quantity - this.partData.shipped_count - this.partData.inventory_count)) {
      this.toastr.error('Quantity cannot exceed balance quantity', 'Error');
    }
    else {
      this.QtyToMoveToInventory += 1;
    }
  }

  subtractQuantity() {
    if (this.QtyToMoveToInventory <= 1) {
      return
    }
    else {
      this.QtyToMoveToInventory -= 1
    }

  }

  close(res?: any) {
    this.dialogref.close(res)
  }

  submit() {
    if (this.QtyToMoveToInventory < 1) {
      this.toastr.error('You can not move 0 quantity to inventory', 'Error');
      return;
    }
    if (this.total_quantity >= (this.inventory_count + this.QtyToMoveToInventory) && this.QtyToMoveToInventory > 0) {
      this.clicked = true;
      let form
      form = {
        "vendor_order_item": {
          "voi_dispatch_batch_attributes": {
            "vendor_order_item_batch_id": this.batchId,
            "total_quantity": this.QtyToMoveToInventory + this.inventory_count,
            "accepted_quantity": this.QtyToMoveToInventory + this.inventory_count,
            "rejected_quantity": 0,
          }
        }
      }
      const balance_qty = this.partData?.quantity - this.partData?.shipped_count - this.partData?.inventory_count;
      if (balance_qty >= 1) {
        this.adminService.createDispatchBatchForOrderBatch(this.orderId, this.partData.vendor_bid_item_id, this.batchId, form).subscribe(
          res => {
            this.toastr.success('Items Moved to Inventory', 'Success');
            this.loaderService.display(false)
            this.close(res);
            setTimeout(() => {
              this.clicked = false;
            }, 500);

          },
          err => {
            this.toastr.error('Something went Wrong', 'Error');
            this.loaderService.display(false)
            setTimeout(() => {
              this.clicked = false;
            }, 500);
          }
        );
      } else {
        this.toastr.error('No parts moved to inventory', 'Error');
        this.loaderService.display(false);
      }
    } else {
      this.toastr.error('Please check the inventory count', 'Error');
      this.loaderService.display(false);
    }
  }

  // fetchBatch() {
  //   this.adminService.fetchVendorOrderItemBatch(this.batchId).subscribe(
  //     (res:any) => {
  //       this.batchDetails = res?.body;
  //       this.loaderService.display(false);
  //       this.toastr.success("Batch stage fetched successfully", "Success");
  //     },
  //     (err) => {
  //       this.loaderService.display(false);
  //       for (let i in err.error.errors) {
  //         this.toastr.error(err.error.errors[i], "Error");
  //       }
  //     }
  //   );
  // }

  // updateStage() {
  //   let formData = new FormData();

  //   formData.append(
  //     "vendor_order_item_batch[stage_update_file]",
  //     this.inspection_file
  //   );
  //   formData.append(
  //     "current_stage",
  //     this.demoForm.value["next_stage"]
  //   );

  //   this.loaderService.display(true);

  //   this.adminService
  //     .updateVendorOrderItemBatch(this.batchId, formData)
  //     .subscribe(
  //       (res) => {
  //         this.loaderService.display(false);
  //         this.toastr.success("Batch stage has been updated", "Success");
  //         this.close();
  //       },
  //       (err) => {
  //         this.loaderService.display(false);
  //         for (let i in err.error.errors) {
  //           this.toastr.error(err.error.errors[i], "Error");
  //         }
  //         this.close();
  //       }
  //     );
  // }

}


// const dialogRef = this.dialog.open(PoReadyToShipComponent, {
//   panelClass: 'my-panel',
//   disableClose: true
// })